<template>
  <div
    class="base-wrap"
    :style="'background: url(' + bgImg + ') no-repeat top center;'"
  >
    <template v-if="loaded">
      <template v-if="!started">
        <img :src="titleImg" class="base-title" />
        <div class="base-detail-bottom">
          <img
            :src="startBtn"
            class="base-start-btn"
            @click="start"
            ref="baseStartBtn"
          />
          <p class="base-join-num">
            Number of participant: {{ detail.join_num }}
          </p>
        </div>
        <img
          :src="detailBtn"
          class="base-detail-btn"
          @click="showDetail = true"
        />
      </template>
      <template v-else>
        <div class="top-content">
          <div class="top-content-wrap">
            <img
              :src="
                this.userDetail && this.userDetail.avatar
                  ? this.userDetail.avatar
                  : avatarDefault
              "
              class="avatar"
            />
            <span class="score">{{ score }}</span>
          </div>
          <div class="times" v-if="isTimeLimit == 1 || isTimeLimit == 2">
            <p>Time</p>
            <div class="times-discount">{{ timeCount }}</div>
          </div>
        </div>
        <div class="question-count" style="margin-top:5rem">
          第<span class="yellow">{{ qsIndex + 1 }}</span
          >题&nbsp;共<span class="yellow">{{ qsList.length }}</span
          >题
        </div>
        <div class="question-title" style="margin: 2.4rem auto 2.8rem;">
          {{ qsList[qsIndex].question_title }}
        </div>
        <template v-for="(item, index) in qsList[qsIndex].answers">
          <div
            class="question-item"
            :key="index"
            :class="
              (item.type == 1 ? 'correct' : 'incorrect') +
                (asIndex === index || (asIndex > -1 && item.type == 1)
                  ? ' active'
                  : '')
            "
          >
            <div
              class="question-item-wrap"
              @click="asItemChoose(index, item.type == 1)"
            >
              {{ item.answer_title }}
              <img
                :src="item.type == 1 ? correctIcon : incorrectIcon"
                v-if="asIndex === index || (asIndex > -1 && item.type == 1)"
                class="as-icon"
              />
            </div>
          </div>
        </template>
      </template>
      <div class="challenge-result" v-if="chanllageStatus > -1">
        <div class="challenge-result-warp">
          <template v-if="chanllageStatus === 1">
            <div class="result-cup">
              <img :src="successCup" />
              <img
                class="result-avatar"
                :src="
                  this.userDetail && this.userDetail.avatar
                    ? this.userDetail.avatar
                    : avatarDefault
                "
              />
            </div>
            <div class="luckydraw-btn" @click="getResult">Lottery draw</div>
          </template>
          <template v-else-if="chanllageStatus === 0">
            <div class="result-cup">
              <img :src="failCup" />
              <img
                class="result-avatar"
                :src="
                  this.userDetail && this.userDetail.avatar
                    ? this.userDetail.avatar
                    : avatarDefault
                "
              />
            </div>
            <div class="luckydraw-btn" @click="handleStart">Play again</div>
          </template>
        </div>
      </div>
      <Form v-if="prizeForm" @close="toIndex" />
      <div
        class="loading"
        @touchmove="showLoading = false"
        v-show="showLoading"
      >
        <Loading bgColor="#0075ff" :loading="showLoading" />
      </div>
      <div class="prize-detail-wrap" v-show="showDetail">
        <PrizeDetail :detail="detail" :myAwards="myAwards" />
        <img :src="closeBtn" class="close-btn" @click="showDetail = false" />
      </div>
    </template>
    <div class="loading" v-else>
      <Loading bgColor="#fff" :loading="!loaded" />
    </div>
  </div>
</template>

<script>
import Loading from "@/components/Loading.vue";
import Form from "@/components/LuckDraw/Form.vue";
import PrizeDetail from "@/components/LuckDraw/PrizeDetail";
import { arrayResort } from "@/util/utils";
import { getLuckDrawConfigure, getLuckDrawResult } from "@/util/data";
const clientWidth =
  window.innerWidth ||
  document.body.clientWidth ||
  document.documentElement.clientWidth;
const baseSize = .85 * (clientWidth > 640 ? 1 : clientWidth / 640);
export default {
  components: {
    Loading,
    Form,
    PrizeDetail
  },
  data() {
    return {
      loaded: false,
      bgImg: require("@/assets/img/ques/qc.jpg"),
      titleImg: require("@/assets/img/ques/qctitle.png"),
      startBtn: require("@/assets/img/ques/qcstart.png"),
      detailBtn: require("@/assets/img/ques/qcdetail.png"),
      avatarDefault: require("@/assets/img/ques/avatar.jpg"),
      correctIcon: require("@/assets/img/ques/right.png"),
      incorrectIcon: require("@/assets/img/ques/wrong.png"),
      successCup: require("@/assets/img/ques/successCupImg.png"),
      failCup: require("@/assets/img/ques/failCupImg.png"),
      closeBtn: require("@/assets/img/close_white.png"),
      detail: {},
      myAwards: [],
      started: false,
      showDetail: false,
      showQuesResult: false,
      showLoading: false,
      isTimeLimit: 0,
      timeLimit: 60,
      timeCount: 60,
      timeCountType: 0,
      chanllageStatus: -1,
      qsList: [],
      qsType: 0,
      asType: 0,
      qsIndex: 0,
      asIndex: -1,
      qsTitle: 0,
      qsScore: 0,
      drawScore: 0,
      score: 0,
      correctNum: 0,
      t: null
      // chance: 1
    };
  },
  mounted() {
    window.document.documentElement.style.fontSize = 20 * baseSize + "px";
    this.loadBaseData();
  },
  computed: {
    resultState() {
      return this.$store.state.showResult;
    },
    messageState() {
      return this.$store.state.showMessage;
    },
    prizeForm() {
      return this.$store.state.showPrizeForm;
    },
    userDetail() {
      return this.$store.state.userDetail;
    }
  },
  watch: {
    resultState(newVal) {
      if (!newVal) {
        this.started = false;
        this.handleStop();
      }
    },
    messageState(newVal) {
      if (!newVal) {
        this.started = false;
        this.handleStop();
      }
    },
    userDetail(newVal) {
      if (newVal) {
        this.loadBaseData();
        this.handleStart();
      }
    }
  },
  methods: {
    toIndex(){
      this.started = false;
      this.handleStop();
    },
    handleStop() {
      this.qsIndex = 0;
      this.asIndex = -1;
      this.score = 0;
      this.timeCount = this.timeLimit;
      this.showQuesResult = false;
      this.chanllageStatus = -1;
      if (this.qsType != 1)
        this.qsList = arrayResort(
          this.qsList,
          this.asType == 1 ? "answers" : ""
        );
    },
    handleStart() {
      this.handleStop();
      this.started = true;
      if (this.isTimeLimit == 1 || this.isTimeLimit == 2)
        this.handleTimeCount();
    },
    checkLogin() {
      let token =
        this.$store.state.token || window.localStorage.getItem("token");
      if (!token) {
        this.$store.commit("updateLoginState", true);
        return false;
      }
      return true;
    },
    loadBaseData() {
      let token =
        this.$store.state.token || window.localStorage.getItem("token") || "";
      getLuckDrawConfigure(
        {
          id: this.$route.params.id
        },
        token
      )
        .then(res => {
          this.loaded = true;
          if (res.code === 1 && res.data) {
            const { my_awards, config } = res.data;
            const {
              answer_type,
              draw_score,
              is_question_time_limit,
              question_time_limit,
              question_type,
              questions,
              questions_score
            } = config;
            this.detail = { ...res.data };
            this.qsScore = questions_score;
            this.drawScore = draw_score;
            this.isTimeLimit = is_question_time_limit; // 是否限制答题时间 0不限制 1总时间限制 2单题时间限制
            this.timeLimit = question_time_limit;
            this.qsList = [...questions];
            this.qsType = question_type; // 题目类型 0随机出题 1固定顺序
            this.asType = answer_type; // 答案类型 0顺序固定 1顺序随机
            this.myAwards = [...my_awards];
          }
        })
        .catch(err => (this.loaded = true));
    },
    start() {
      let btn = this.$refs["baseStartBtn"];
      btn.className += " active";
      setTimeout(() => {
        btn.className = btn.className.replace(" active", "");
        if (!this.checkLogin()) return;
        const endTime = this.detail.end_time
          ? new Date(this.detail.end_time.replace(/-/g, "/")).getTime()
          : "";
        const nowTime = new Date().getTime();
        if (!endTime || endTime < nowTime) {
          this.showMessage("Game over!");
          return;
        }
        this.handleStart();
      }, 100);
    },
    handleTimeCount() {
      this.t = setInterval(() => {
        if (this.timeCount <= 0.1) {
          clearInterval(this.t);
          this.t = null;
          if (this.isTimeLimit == 2) this.changeNext();
          else this.chanllageStatus = this.score >= this.drawScore ? 1 : 0;
        } else this.timeCount = (this.timeCount - 0.08).toFixed(2);
      }, 80);
    },
    asItemChoose(index, isCorrect) {
      if (this.asIndex > -1) return;
      this.asIndex = index;
      if (isCorrect) {
        this.correctNum += 1;
        this.score = this.correctNum * this.qsScore;
      }
      if (this.t) clearInterval(this.t);
      setTimeout(() => {
        this.changeNext();
      }, 1500);
    },
    changeNext() {
      if (this.qsIndex < this.qsList.length - 1) {
        if (this.isTimeLimit == 1 || this.isTimeLimit == 2) {
          if (this.isTimeLimit == 2) this.timeCount = this.timeLimit;
          this.handleTimeCount();
        }
        this.qsIndex += 1;
        this.asIndex = -1;
      } else {
        this.chanllageStatus = this.score >= this.drawScore ? 1 : 0;
      }
    },
    getResult() {
      // if(this.chance<1){
      //   this.showMessage("No chance today, come back tomorrow.!");
      //   return;
      // }
      let token =
        this.$store.state.token || window.localStorage.getItem("token");
      getLuckDrawResult(
        {
          activity_id: this.$route.params.id
        },
        token
      )
        .then(res => {
          if (res.code === 1 && res.data && res.data.award) {
            this.handleResult(res.data);
          } else {
            this.showLoading = false;
            this.showMessage(res.msg || "Failed!");
          }
        })
        .catch(err => {
          const msg = typeof err === "object" ? JSON.stringify(err) : err;
          this.showMessage(msg === "{}" || !msg ? "Failed!" : msg);
          this.showLoading = false;
        });
    },
    handleResult(data) {
      this.chance -= 1;
      const { id, title, level, image } = data.award;
      if (id) this.myAwards.unshift({ id, title, level, image });
      this.showLoading = false;
      if (id === 0) {
        this.showResult({ type: 1 });
      } else {
        this.showResult({ type: 3, title, level });
      }
    },
    getImageByPrizeId(id) {
      let imageUrl = "";
      this.defaultPrize.forEach(item => {
        if (item.id == id) {
          imageUrl = item.image;
        }
      });
      return imageUrl;
    },
    showMessage(text) {
      this.$store.commit("updateValue", ["showMessage", true]);
      this.$store.commit("updateValue", ["messageContent", text]);
    },
    showResult(obj) {
      this.$store.commit("updateValue", ["showResult", true]);
      this.$store.commit("updateValue", ["prizeResult", { ...obj }]);
    }
  }
};
</script>

<style scoped lang="scss">
* {
  transition: all 0.4s cubic-bezier(0.075, 0.82, 0.165, 1);
}

img {
  display: block;
  max-width: 100%;
}

.base-wrap {
  position: relative;
  width: 37.5rem;
  margin: 0 auto;
  height: 100vh;
  background-size: 100% auto !important;
  color: #fff;
}
.yellow {
  color: rgb(255, 235, 16);
}
.base-title {
  width: 100%;
  margin: 0 auto;
  padding-top: 12rem;
}
.base-detail-btn {
  position: absolute;
  right: 2rem;
  top: 0;
  width: 8.6rem;
  transform-origin: center;
  // animation: sizeChange 2s linear infinite forwards;
}
.base-detail-bottom{
  width: 100%;
  position: absolute;
  bottom: 6.2rem;
  left: 0;
}
.base-start-btn {
  width: 10rem;
  position: relative;
  margin: 0 auto 2.4rem;
  transform: translate(0.5rem, 0);
  &.active {
    transform: translate(0.5rem, 0) scale(1.1);
  }
}
.base-join-num {
  margin-top: 0.5rem;
  font-size: 1.6rem;
  text-align: center;
  color: #276bd0;
  text-shadow: -1px -1px 0 #fff, 0 -1px 0 #fff, 1px -1px 0 #fff, 1px 0 0 #fff,
    1px 1px 0 #fff, 0 1px 0 #fff, -1px 1px 0 #fff, -1px 0 0 #fff;
}
.top-content {
  position: relative;
  font-size: 1.6rem;

  .top-content-wrap {
    padding: 1.2rem 1.8rem 0;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    .avatar {
      width: 5.8rem;
      margin-right: 0.5rem;
      border-radius: 50%;
    }
  }
  .times {
    padding-top: 1.2rem;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    .times-discount {
      font-size: 3rem;
      font-weight: bold;
    }
  }
}
.question-count,
.question-title {
  margin-top: 2.4rem;
  text-align: center;
  font-size: 1.6rem;
}
.question-title {
  margin: 1.8rem auto 3.8rem;
  text-align: left;
  width: 33rem;
}
.question-item {
  position: relative;
  width: 33rem;
  line-height: 5.6rem;
  background: #fff;
  border-radius: 8px;
  margin: 0 auto 1.8rem;
  color: #0c2373;
  transition: background  0.4s cubic-bezier(0.075, 0.82, 0.165, 1);
  .question-item-wrap {
    padding: 0 1.5rem;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    text-align: center;
    font-size: 1.6rem;
  }
  .as-icon {
    display: none;
    position: absolute;
    right: 0;
    width: 2.4rem;
    top: 50%;
    transform: translate(48%, -50%);
  }
  &.active {
    color: #fff;
    .as-icon {
      display: block;
    }
    &.correct {
      background: #20c291;
    }
    &.incorrect {
      background: #fe6d74;
    }
  }
}
.challenge-result {
  position: fixed;
  z-index: 9999;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.85);
  width: 100%;
  height: 100%;
  .challenge-result-warp {
    position: absolute;
    left: 50%;
    top: 40%;
    transform: translate(-50%, -50%);
    .result-cup {
      width: 23.4rem;
      position: relative;
      z-index: 2;
      margin: 0 auto;
      .result-avatar {
        width: 4.1rem;
        position: absolute;
        left: 50%;
        top: 33.9%;
        transform: translate(-50%, 0);
        border-radius: 100%;
      }
    }
    .result-wrap {
      position: relative;
      z-index: 1;
      margin: -4.5rem auto 0;
      background: #fff;
      width: 26.4rem;
      padding: 4.5rem 0 6rem;
      border-radius: 0.9rem;
    }
    .luckydraw-btn {
      background: #f33061;
      font-size: 1.6rem;
      line-height: 4rem;
      border-radius: 2rem;
      width: 23.4rem;
      margin: 4rem auto 0;
      text-align: center;
      color: #feeea3;
    }
  }
}
.loading {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  z-index: 666;
  display: flex;
  align-items: center;
  justify-content: center;
}
.prize-detail-wrap {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  background: #fff;
  transition: none;
  animation: fadeIn 0.6s cubic-bezier(0.43, 1.13, 0.97, 1.11);
  overflow-y: scroll;
  .close-btn {
    width: 2.8rem;
    padding: 0.6rem;
    border-radius: 100%;
    background: rgba(0, 0, 0, 0.4);
    position: fixed;
    top: 1rem;
    right: 1rem;
  }
}
@media screen and (max-width: 321px) {
  .base-join-num {
    font-size: 12px;
  }
}
@keyframes sizeChange {
  5% {
    transform: scale(1);
  }
  45% {
    transform: scale(0.95);
  }
  55% {
    transform: scale(0.95);
  }
  95% {
    transform: scale(1);
  }
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/QuestionChallenge.vue